import React from "react";

import clsx from "clsx";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import TextField from "@material-ui/core/TextField";

// copied from https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/DialogActions/DialogActions.js
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    actions: {
      display: "flex",
      alignItems: "center",
      padding: 8,
      justifyContent: "flex-end",
      flex: "0 0 auto",
    },
    spacing: {
      "& > * + *": {
        marginLeft: 8,
      },
    },
  })
);

interface Props {
  name?: string;
  label?: string;
  value: any;
  required?: boolean;
  // onChange: (event: any) => void
  className?: string;
  inputProps?: any;
  itemToString: (value: any) => string;
  // closeDialogOnSelection?: boolean
  children: any;

  onAccept?: (event: any) => void;
  onDismiss?: (event: any) => void;
  supportDefault?: boolean;
}

// TODO Replace with CustomSelectSimple and CustomSelectAdvanced
function CustomSelect(props: Props) {
  const classes = useStyles(props);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  function handleOpen(
    event: React.MouseEvent<HTMLElement> | React.FocusEvent<HTMLElement>
  ) {
    setAnchorEl(event.currentTarget);
    // setAnchorEl(anchorEl ? null : event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleAccept(event: any) {
    if (onAccept) {
      onAccept(event);
    }
    handleClose();
  }

  function handleDismiss(event: any) {
    if (onDismiss) {
      onDismiss(event);
    }
    handleClose();
  }

  const open = Boolean(anchorEl);
  // const id = open ? 'custom-select-popup' : undefined;

  const {
    value,
    label,
    required,
    itemToString,
    inputProps,
    onAccept,
    onDismiss,
    supportDefault = false,
  } = props;
  return (
    <div className={props.className}>
      <TextField
        // id="custom-select-text-field"
        label={label}
        InputLabelProps={{
          // ...getLabelProps(),
          shrink: open || !!value, // TODO || !!fromDate || !!toDate
        }}
        // placeholder="From:"
        margin="none"
        fullWidth
        InputProps={{
          ...inputProps,
          readOnly: true,
          onClick: handleOpen,
          // onFocus: handleOpen
        }}
        value={itemToString(value)}
        required={required}
      />
      <Popover
        // id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        // PaperProps={{ style: { overflowX: "auto" } }}
        style={{
          maxWidth: "75vw",
          // maxHeight: '75vh'
        }}
      >
        {/* TODO find a better solution to always show the action bar! */}
        <div style={{ overflowX: "auto", height: "calc(100vh - 96px)" }}>
          {props.children}
        </div>
        <div className={clsx(classes.actions, classes.spacing)}>
          {!!supportDefault && (
            <Button color="primary" onClick={() => handleAccept(null)}>
              Reset to default
            </Button>
          )}
          <Button color="primary" onClick={handleDismiss}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleAccept}>
            OK
          </Button>
        </div>
      </Popover>
    </div>
  );
}

export default CustomSelect;
